<template>
  <div class="AppStoreDetails">
    <div class="sub-menu-section">
      <div class="flex">
        <!-- <div
          class="tab-link cursor-pointer"
          :class="{ 'active-tab-link': active_tab_link == 'ACCOUNT_DETAILS' }"
          @click="setActiveTabLink('ACCOUNT_DETAILS')"
        >
          Location Details
        </div> -->
        <div
          v-if="
            email != 'rkhan@burgerking.in' &&
            email != 'vdhanuka@burgerking.in' &&
            email != 'ukhemka@burgerking.in' &&
            email != 'ssinha@burgerking.in' &&
            email != 'ntiwari@burgerking.in' ||
            checkCompany.is_sb_malaysia ||
            checkCompany.is_sb_india
          "
          class="tab-link cursor-pointer ml-6"
          :class="{ 'active-tab-link': active_tab_link == 'CLUSTER_DETAILS' }"
          @click="setActiveTabLink('CLUSTER_DETAILS')"
        >
          Cluster Details
        </div>
        <!-- <div
          class="tab-link cursor-pointer ml-6"
          :class="{ 'active-tab-link': active_tab_link == 'USER_GROUPS' }"
          @click="setActiveTabLink('USER_GROUPS')"
        >
          User Groups
        </div> -->
      </div>

      <div class="flex" style="margin-left: auto">
        <el-button
          v-if="active_tab_link == 'ACCOUNT_DETAILS'"
          class="action-btn"
          size="small"
          style="width: 120px"
          @click="() => $router.push((path = '/test-account/add')).catch(()=>{})"
          >Add Test Store</el-button
        >
        <el-button
          v-if="active_tab_link == 'ACCOUNT_DETAILS'"
          class="action-btn"
          size="small"
          style="width: 120px"
          @click="() => $router.push((path = '/account/add')).catch(()=>{})"
          >Add Location</el-button
        >
        <el-button
          v-if="active_tab_link == 'CLUSTER_DETAILS'"
          class="action-btn"
          size="small"
          style="width: 120px"
          @click="() => $router.push((path = '/create-cluster')).catch(()=>{})"
          >Create Cluster</el-button
        >
        <el-button
          v-if="active_tab_link == 'USER_GROUPS'"
          class="action-btn"
          size="small"
          style="width: 120px"
          @click="addNewUserGroup"
          >
          Create Group&nbsp;&nbsp;<i class="el-icon-plus"></i>
          </el-button
        >
      </div>
    </div>
    <div>
      <el-row :gutter="20">
        <!-- <el-col
					:xs="24"
					:sm="12"
					:md="{ span: 5, offset: 19 }"
					:lg="{ span: 4, offset: 20 }"
					:xl="{ span: 4, offset: 20 }"
					class="col-margin-top"
				>
					<div class="w-24 float-right">
						<BaseButton
							buttonclass="btn p-2 text-xs"
							@click="() => $router.push((path = '/account/add'))"
						>
							Add Account
						</BaseButton>
					</div>
				</el-col> -->
        <!-- <el-col
					:xs="24"
					:sm="12"
					:md="5"
					:lg="4"
					:xl="4"
					class="col-margin-top"
				>
					<BaseButton
						buttonclass="btn p-2 text-sm"
						@click="() => $router.push({ name: 'AppUserPermissions' })"
					>
						User Permissions
					</BaseButton>
				</el-col> -->
      </el-row>
    </div>

    <div v-if="active_tab_link == 'ACCOUNT_DETAILS'">
      <div class="top-margin">
        <el-row>
          <el-col
            :xs="24"
            :sm="12"
            :md="8"
            :lg="8"
            :xl="8"
            class="col-margin-top"
          >
          </el-col>
          <el-col
            :xs="24"
            :sm="12"
            :md="16"
            :lg="16"
            :xl="16"
            class="col-margin-top text-right"
          >
            <!-- <div class="export-heading">
              <span @click="downloadCsvReport(outletWithUsers)"
                >Export to .csv</span
              >
            </div> -->
            <el-button
              type="warning"
              size="small"
              style="width: 120px"
              @click="downloadCsvReport(outletWithUsers)"
            >
              CSV&nbsp;&nbsp;<i class="el-icon-download"></i>
            </el-button>
          </el-col>
        </el-row>
        <div
          v-loading="is_store_details_loading"
          class="col-margin-top store-details-table"
        >
          <simplebar class="simplebar">
            <table>
              <thead>
                <th class="width20">Location Name</th>
                <th class="width11">Location Type</th>
                <th class="width11">Full Name</th>
                <th class="width11">Designation</th>
                <th class="width11">User Permission</th>
                <th class="width11">Access</th>
                <th class="width11">Status</th>
                <th class="width11">&nbsp;</th>
              </thead>

              <tbody
                v-for="(outlet, index) in outletWithUsers"
                :key="index"
                style="margin-top: 50px"
              >
                <tr>
                  <td
                    class="width20 heading"
                    style="justify-content: flex-start !important"
                  >
                    <span
                      class="mr-4 cursor-pointer"
                      @click="toggleRow(index, 'HEAD_OFFICE')"
                    >
                      <i
                        v-if="!outlet.is_toggled"
                        class="el-icon-circle-plus toggle-icon"
                      ></i>
                      <i
                        v-if="outlet.is_toggled"
                        class="el-icon-remove toggle-icon"
                      ></i>
                    </span>
                    <span
                      style="cursor: pointer"
                      @click="
                        () =>
                          $router.push({
                            name: 'EditAccount',
                            params: { accountId: outlet.id, type: outlet.type },
                          }).catch(()=>{})
                      "
                    >
                      {{ outlet.name }}
                    </span>
                  </td>

                  <td class="width11">
                    {{ outlet.type }}
                  </td>

                  <table style="display: block">
                    <tbody
                      v-for="(user, user_index) in outlet.users"
                      :key="user_index"
                    >
                      <tr>
                        <td v-if="user_index > 0" class="width20">&nbsp;</td>
                        <td v-if="user_index > 0" class="width11">&nbsp;</td>
                        <td class="border-bottom width11">
                          {{ user.full_name }}
                        </td>
                        <td class="border-bottom width11">
                          {{
                            user.designation_info
                              ? user.designation_info.name
                              : "-"
                          }}
                        </td>
                        <td class="border-bottom width11">
                          {{
                            user.access_level == "employee"
                              ? "Staff"
                              : user.access_level
                          }}
                        </td>
                        <td class="border-bottom width11">{{ outlet.name }}</td>
                        <td class="border-bottom width11">{{ user.status }}</td>
                        <td class="border-bottom width11">
                          <img
                            src="../../../assets/images/edit.png"
                            style="width: 17px; cursor: pointer; color: #e29d5a; margin-right: 10px;"
                            @click="
                              openEditAccountUserPopup(
                                user,
                                user_index,
                                outlet.id,
                                outlet.type,
                                index,
                                null,
                                null,
                                null,
                                null
                              )
                            "
                          />

                          <img
                            src="../../../assets/images/delete-icon.png"
                            style="width: 17px; cursor: pointer; color: #e29d5a"
                            @click="deleteUser(user.email)"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </tr>

                <template v-for="(region, region_index) in outlet.regions">
                  <tr
                    v-if="outlet.is_toggled"
                    :key="'region_index_'+region_index"
                  >
                    <td
                      class="width20 heading"
                      style="justify-content: flex-start !important; text-align: left;"
                    >
                      <div style="margin-left: 15px" class="flex">
                        <p
                          class="mr-4 cursor-pointer"
                          @click="toggleRow(index, 'REGION', region_index)"
                        >
                          <i
                            v-if="!region.is_toggled"
                            class="el-icon-circle-plus toggle-icon"
                          ></i>
                          <i
                            v-if="region.is_toggled"
                            class="el-icon-remove toggle-icon"
                          ></i>
                        </p>
                        <p
                          style="cursor: pointer"
                          class="region_ellipsis"
                          @click="
                            () =>
                              $router.push({
                                name: 'EditAccount',
                                params: {
                                  accountId: region.id,
                                  type: region.type,
                                },
                              }).catch(()=>{})
                          "
                        >
                          {{ region.name }}
                          <!-- <div class="region_ellipsis">
                          </div> -->
                        </p>
                        <!-- {{ region.name }} -->
                      </div>
                    </td>

                    <td class="width11">
                      {{ region.type }}
                    </td>

                    <table style="display: block">
                      <tbody
                        v-for="(user, region_user_index) in region.users"
                        :key="region_user_index"
                        class="border-bottom"
                      >
                        <tr>
                          <td v-if="region_user_index > 0" class="width20">
                            &nbsp;
                          </td>
                          <td v-if="region_user_index > 0" class="width11">
                            &nbsp;
                          </td>
                          <td class="width11">{{ user.full_name }}</td>
                          <td class="width11">
                            {{
                              user.designation_info
                                ? user.designation_info.name
                                : "-"
                            }}
                          </td>
                          <td class="width11">
                            {{
                              user.access_level == "employee"
                                ? "Staff"
                                : user.access_level
                            }}
                          </td>
                          <td class="width11">{{ region.type }}</td>
                          <td class="width11">{{ user.status }}</td>
                          <td class="width11">
                            <img
                              src="../../../assets/images/edit.png"
                              style="
                                width: 17px;
                                cursor: pointer;
                                color: #e29d5a;
                                margin-right: 10px;
                              "
                              @click="
                                openEditAccountUserPopup(
                                  user,
                                  region_user_index,
                                  region.id,
                                  region.type,
                                  index,
                                  region_index,
                                  null,
                                  null,
                                  null
                                )
                              "
                            />

                            <img
                              src="../../../assets/images/delete-icon.png"
                              style="width: 17px; cursor: pointer; color: #e29d5a"
                              @click="deleteUser(user.email)"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <table v-if="region.is_toggled">
                      <tbody
                        v-for="(subregion, subregion_index) in region.subregions"
                        :key="subregion_index"
                        class="border-bottom"
                      >
                        <tr>
                          <td
                            class="width20 heading"
                            style="justify-content: flex-start !important"
                          >
                            <div style="margin-left: 30px">
                              <span
                                class="mr-4 cursor-pointer"
                                @click="
                                  toggleRow(
                                    index,
                                    'SUB_REGION',
                                    region_index,
                                    subregion_index
                                  )
                                "
                              >
                                <i
                                  v-if="!subregion.is_toggled"
                                  class="el-icon-circle-plus toggle-icon"
                                ></i>
                                <i
                                  v-if="subregion.is_toggled"
                                  class="el-icon-remove toggle-icon"
                                ></i>
                              </span>
                              <span
                                style="cursor: pointer"
                                @click="
                                  () =>
                                    $router.push({
                                      name: 'EditAccount',
                                      params: {
                                        accountId: subregion.id,
                                        type: subregion.type,
                                      },
                                    }).catch(()=>{})
                                "
                              >
                                {{ subregion.name }}
                              </span>
                              <!-- {{ subregion.name }} -->
                            </div>
                          </td>

                          <td class="width11">{{ subregion.type }}</td>

                          <table style="display: block">
                            <tbody
                              v-for="(
                                usr, subregion_user_index
                              ) in subregion.users"
                              :key="subregion_user_index"
                              class="border-bottom"
                            >
                              <tr>
                                <td
                                  v-if="subregion_user_index > 0"
                                  class="width20"
                                >
                                  &nbsp;
                                </td>
                                <td
                                  v-if="subregion_user_index > 0"
                                  class="width11"
                                >
                                  &nbsp;
                                </td>
                                <td class="width11">
                                  {{ usr.full_name }} {{ usr.last_name }}
                                </td>
                                <td class="width11">
                                  {{
                                    usr.designation_info
                                      ? usr.designation_info.name
                                      : "-"
                                  }}
                                </td>
                                <td class="width11">
                                  {{
                                    usr.access_level == "employee"
                                      ? "Staff"
                                      : usr.access_level
                                  }}
                                </td>
                                <td class="width11">{{ subregion.type }}</td>
                                <td class="width11">{{ usr.status }}</td>
                                <td class="width11">
                                  <img
                                    src="../../../assets/images/edit.png"
                                    style="
                                      width: 17px;
                                      cursor: pointer;
                                      color: #e29d5a;
                                      margin-right: 10px;
                                    "
                                    @click="
                                      openEditAccountUserPopup(
                                        usr,
                                        subregion_user_index,
                                        subregion.id,
                                        subregion.type,
                                        index,
                                        region_index,
                                        subregion_index,
                                        null,
                                        region.id
                                      )
                                    "
                                  />
                                  <img
                                    src="../../../assets/images/delete-icon.png"
                                    style="
                                      width: 17px;
                                      cursor: pointer;
                                      color: #e29d5a;
                                    "
                                    @click="deleteUser(usr.email)"
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </tr>

                        <template
                          v-for="(store, store_index) in subregion.outlets"
                        >
                          <tr
                            v-if="subregion.is_toggled"
                            :key="'store_index_'+store_index"
                          >
                            <td
                              class="width20 heading"
                              style="justify-content: flex-start !important; text-align: left;"
                            >
                              <div style="margin-left: 80px" class="ellipsis">
                                <span
                                  style="cursor: pointer"
                                  @click="
                                    () =>
                                      $router.push({
                                        name: 'EditAccount',
                                        params: {
                                          accountId: store.id,
                                          type: store.type,
                                        },
                                      }).catch(()=>{})
                                  "
                                >
                                  <el-tooltip
                                    :content="store.name"
                                    placement="top"
                                    effect="light"
                                  >
                                    <span>{{ store.name }}</span>
                                  </el-tooltip>
                                </span>
                                <!-- {{ store.name }} -->
                              </div>
                            </td>

                            <td class="width11">{{ store.type }}</td>

                            <table style="display: block">
                              <tbody
                                v-for="(usr, outlet_user_index) in store.users"
                                :key="outlet_user_index"
                                class="border-bottom"
                              >
                                <tr>
                                  <td v-if="outlet_user_index > 0" class="width20">
                                    &nbsp;
                                  </td>
                                  <td v-if="outlet_user_index > 0" class="width11">
                                    &nbsp;
                                  </td>
                                  <td class="width11">
                                    {{ usr.full_name }} {{ usr.last_name }}
                                  </td>
                                  <td class="width11">
                                    {{
                                      usr.designation_info
                                        ? usr.designation_info.name
                                        : "-"
                                    }}
                                  </td>
                                  <td class="width11">
                                    {{
                                      usr.access_level == "employee"
                                        ? "Staff"
                                        : usr.access_level
                                    }}
                                  </td>
                                  <td class="width11">&nbsp;</td>
                                  <td class="width11">{{ usr.status }}</td>
                                  <td class="width11">
                                    <img
                                      src="../../../assets/images/edit.png"
                                      style="
                                        width: 17px;
                                        cursor: pointer;
                                        color: #e29d5a;
                                        margin-right: 10px;
                                      "
                                      @click="
                                        openEditAccountUserPopup(
                                          usr,
                                          outlet_user_index,
                                          store.id,
                                          store.type,
                                          index,
                                          region_index,
                                          subregion_index,
                                          store_index,
                                          null
                                        )
                                      "
                                    />
                                    <img
                                      src="../../../assets/images/delete-icon.png"
                                      style="
                                        width: 17px;
                                        cursor: pointer;
                                        color: #e29d5a;
                                      "
                                      @click="deleteUser(usr.email)"
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </tr>
                </template>
                <!-- <tr valign="top">
									<td
										scope="row"
										:rowspan="outlet.users.length + 1"
										style="max-width: 300px;"
									>
										<div
											:style="{
												'margin-left':
													outlet.type == 'region'
														? '30px'
														: outlet.type == 'subregion' ||
														(outlet.type == 'outlet' && outlet.regionOutlet)
														? '60px'
														: outlet.type == 'outlet' ||
														outlet.type == 'vendor' ||
														outlet.type == 'store' ||
														outlet.type == 'central_kitchen'
														? '90px'
														: '0'
											}"
											class="truncate"
											style="cursor: pointer; text-align: left;"
										>
											<span v-if="outlet.type != 'outlet' &&
															outlet.type != 'vendor' &&
															outlet.type != 'store' &&
															outlet.type != 'central_kitchen'">
												<span
													v-if="outlet.index"
													class="mr-4"
													@click="ShowRow(outlet.id, index)"
												>
													<i
														class="el-icon-circle-plus"
														style="color: #e29d5a; font-size:15px"
													></i>
												</span>
												<span
													v-if="!outlet.index && outlet.type != 'outlet'"
													class="mr-4"
													@click="hideRow(outlet.id, index)"
												>
													<i
														class="el-icon-remove"
														style="color: #e29d5a; font-size:15px"
													></i>
												</span>
											</span>
											<span
												style="font-weight: bold; color: #2c9bce; cursor:
												pointer;"
												@click="
													() =>
														$router.push({
															name: 'EditAccount',
															params: { accountId: outlet.id, type: outlet.type }
														})
												"
											>
											<el-tooltip :content="outlet.name" placement="top" effect="light">
												<span>{{ outlet.name }}</span>
											</el-tooltip>
											</span>
										</div>
									</td>
									<td scope="row" :rowspan="outlet.users.length + 1">
										{{ outlet.type }}
									</td>
									<td v-if="!outlet.users.length" scope="row">
										&nbsp;
									</td>
									<td v-if="!outlet.users.length" scope="row">
										&nbsp;
									</td>
									<td v-if="!outlet.users.length" scope="row">
										&nbsp;
									</td>
									<td v-if="!outlet.users.length" scope="row">
										&nbsp;
									</td>
									<td v-if="!outlet.users.length" scope="row">
										&nbsp;
									</td>
									<td v-if="!outlet.users.length" scope="row">
										&nbsp;
									</td>
								</tr>
								<tr
									v-for="(user, index2) in outlet.users"
									:key="index2"
									class="user-detail-tr"
								>
									<td>{{ user.full_name }}</td>
									<td>{{ user.designation }}</td>
									<td style="width: 180px;">
										<span
											v-for="(permision, PerIndex) in userPermision"
											v-if="user.access_level"
											:key="PerIndex"
										>
											<span v-if="user.access_level == permision.id">
												{{ permision.name }}
											</span>
										</span>
									</td>
									<td>
										<span v-if="user.access_outlet">
											<span v-for="(out, outIndex) in outlets" :key="outIndex">
												<span v-if="user.access_outlet == out.id">
													{{ out.name }}</span
												>
											</span>
										</span>
										<span v-if="user.access_region.length">
											<span
												v-for="(region, regionIndex) in regions"
												:key="regionIndex"
											>
												<span
													v-for="(userRegion,
													userRegionIndex) in user.access_region"
													:key="userRegionIndex"
												>
													<span v-if="region.id == userRegion">
														{{ region.name }}</span
													>
												</span>
											</span>
										</span>
										<span v-if="user.access_subregion.length">
											<span
												v-for="(Subregion, SubregionIndex) in subregions"
												:key="SubregionIndex"
											>
												<span
													v-for="(userSubRegion,
													userSubRegionIndex) in user.access_subregion"
													:key="userSubRegionIndex"
												>
													<span v-if="Subregion.id == userSubRegion">
														{{ Subregion.name }}</span
													>
												</span>
											</span>
										</span>
									</td>
									<td>
										{{ user.status }}
									</td>
									<td style="width: 120px;">
										<img
											src="../../../assets/images/edit.png"
											style="width: 17px; cursor: pointer; color: #e29d5a; margin-right: 10px;"
											@click="
												openEditAccountUserPopup(
													user,
													index2,
													outlet.id,
													outlet.Dataindex,
													outlet.type
												)
											"
										/>
										<img
											src="../../../assets/images/delete-icon.png"
											style="width: 17px; cursor: pointer; color: #e29d5a;"
											@click="deleteUser(user.email)"
										/>
									</td>
								</tr> -->
              </tbody>
            </table>
          </simplebar>
        </div>
      </div>
      <!-- <div class="text-right">
				<el-pagination
					background
					:current-page.sync="pageInfo.currentPage"
					:page-sizes="[5, 10, 15]"
					:page-size.sync="pageInfo.pageSize"
					layout="sizes, prev, pager, next"
					:total="pageInfo.totalCount"
					@size-change="handlePageInfoChange"
					@current-change="handlePageInfoChange"
				/>
			</div> -->
      <el-dialog
        :key="editBaseAccountUserPopupKey"
        title="Edit user!"
        :visible.sync="showEditBaseAccountUserPopup"
        width="50%"
        :before-close="closePopup"
      >
	      <form data-vv-scope="form-1">
          <el-row class="py-2 pl-12 flex items-center">
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
              <p class="text-xs font-bold pb-1">
                Full Name <span style="color: red">*</span>
              </p>
            </el-col>
            <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
              <div class="flex">
                <BaseInput
                  v-model="accountUserDetails.full_name"
                  v-validate="'required'"
                  :name="'Full Name' + accountUserIndex"
                  style="width: 100%"
                  class="baseInput"
                  custom-class="p-2 text-sm text-amp-input-boxes"
                  placeholder="Full Name"
                />
              </div>
              <p
                v-show="errors.has('form-1.Full Name' + accountUserIndex)"
                class="text-red-dark text-xs"
              >
                {{ errors.first("form-1.Full Name" + accountUserIndex) }}
              </p>
            </el-col>
          </el-row>
        <!-- <el-row class="py-2 pl-12 flex items-center">
					<el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
						<p class="text-xs font-bold pb-1">Last Name <span style="color:red;">*</span></p>
					</el-col>
					<el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
						<div class="flex">
							<BaseInput
								v-model="accountUserDetails.last_name"
								v-validate="'required'"
								:name="'last Name' + accountUserIndex"
								style="width: 100%;"
								class="baseInput"
								custom-class="p-2 text-sm text-amp-input-boxes"
								placeholder="Last Name"
							/>
						</div>
						<p
							v-show="errors.has('last Name' + accountUserIndex)"
							class="text-red-dark text-xs"
						>
							{{ errors.first("last Name" + accountUserIndex) }}
						</p>
					</el-col>
				</el-row> -->
          <el-row class="py-2 pl-12 flex items-center">
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
              <p class="text-xs font-bold pb-1">
                Designation <span style="color: red">*</span>
              </p>
            </el-col>
            <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
              <div class="flex flex-wrap">
                <!-- <BaseInput
                  v-model="accountUserDetails.designation"
                  v-validate="'required'"
                  :name="'Designation' + accountUserIndex"
                  style="width: 100%;"
                  class="baseInput"
                  custom-class="p-2 text-sm text-amp-input-boxes"
                  placeholder="Enter Designation"
                /> -->
                <el-select
                  v-model="accountUserDetails.designation"
                  v-validate="'required'"
                  filterable
                  style="width: 100%"
                  placeholder="Select Designation"
                  :name="'Designation' + accountUserIndex"
                  size="small"
                  class="capitalize"
                  @input="addDesignation($event)"
                  @change="selectDesignInfo(accountUserDetails.designation)"
                >
                  <!-- :disabled="filter_.id ? true : false"
                      @change="getFunctionList()" -->
                  <el-option
                    label="add new"
                    value="add new"
                    style="color: #e29d5a"
                    >Add-Edit Designation</el-option
                  >
                  <el-option
                    v-for="(item, index) in designationList"
                    :key="index"
                    :value="item.id"
                    :label="item.name"
                    class="capitalize"
                  >
                    <!-- :disabled="store_name.includes('all')" -->
                    {{ item.name }}
                  </el-option>
                </el-select>
                <span
                  v-show="errors.has('form-1.Designation' + accountUserIndex)"
                  class="text-red-dark text-xs"
                  >{{ errors.first("form-1.Designation" + accountUserIndex) }}</span
                >
              </div>
            </el-col>
          </el-row>
          <el-row class="py-2 pl-12 flex items-center">
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
              <p class="text-xs font-bold pb-1">
                Email <span style="color: red">*</span>
              </p>
            </el-col>
            <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
              <div class="flex flex-wrap">
                <BaseInput
                  v-model="accountUserDetails.email"
                  v-validate="'required|email'"
                  :name="'Email' + accountUserIndex"
                  style="width: 100%"
                  class="baseInput lowercase"
                  custom-class="p-2 text-sm email text-amp-input-boxes"
                  placeholder="Enter Email Id"
                />
                <span
                  v-show="errors.has('form-1.Email' + accountUserIndex)"
                  class="text-red-dark text-xs"
                  >{{ errors.first("form-1.Email" + accountUserIndex) }}</span
                >
              </div>
            </el-col>
          </el-row>
          <el-row class="py-2 pl-12 flex items-center">
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
              <p class="text-xs font-bold pb-1">Mobile No</p>
            </el-col>
            <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
              <div class="flex flex-wrap">
                <BaseInput
                  v-model="accountUserDetails.phone_number"
                  :name="'Contact' + accountUserIndex"
                  style="width: 100%"
                  class="baseInput"
                  custom-class="p-2 text-sm  text-amp-input-boxes"
                  placeholder="Mobile No"
                />
              </div>
            </el-col>
          </el-row>
          <el-row class="py-2 pl-12 flex items-center">
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
              <p class="text-xs font-bold pb-1">Access Level</p>
            </el-col>
            <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
              <div
                v-if="accountUserDetails.type == 'store'"
                class="flex flex-wrap"
              >
                <el-select
                  v-model="accountUserDetails.access_level"
                  v-validate="'required'"
                  style="width: 100%"
                  placeholder="Select Access"
                  name="Account Type"
                >
                  <el-option
                    v-if="accountUserDetails.type != 'head_office'"
                    label="Store User"
                    value="outlet"
                  >
                    Store User
                  </el-option>
                  <el-option label="Staff" value="employee"> Staff </el-option>
                </el-select>
              </div>

              <div v-else class="flex flex-wrap">
                <el-select
                  v-model="accountUserDetails.access_level"
                  v-validate="'required'"
                  style="width: 100%"
                  placeholder="Select Access"
                  name="Account Type"
                >
                  <!-- :disabled="accountUserDetails.type != 'head_office'" -->
                  <el-option
                    v-if="accountUserDetails.type != 'head_office'"
                    label="Store User"
                    value="outlet"
                  >
                    Store User
                  </el-option>
                  <el-option label="Regional User" value="region">
                    Regional User
                  </el-option>
                  <el-option label="Sub Regional User" value="sub_region">
                    Sub Regional User
                  </el-option>
                  <el-option label="Super" value="super"> Super </el-option>
                  <el-option
                    v-if="accountUserDetails.type == 'vender'"
                    label="Vender"
                    value="vender"
                  >
                    Vender
                  </el-option>
                  <el-option label="Admin" value="admin"> Admin </el-option>
                </el-select>
              </div>
            </el-col>
          </el-row>

          <el-row v-if="accountUserDetails.access_level == 'region' || accountUserDetails.access_level == 'sub_region'"
            class="py-2 pl-12 flex items-center"
          >
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
              <p class="text-xs font-bold pb-1">Region</p>
            </el-col>

            <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
              <div class="flex">
                <el-select
                  v-model="accountUserDetails.access_region"
                  class="custom-input"
                  placeholder="Select Region"
                  style="width: 100%"
                  name="Select Region"
                >
                  <!-- :disabled="accountUserDetails.type != 'head_office'" -->
                  <el-option
                    v-for="(region, region_index) in regions"
                    :key="region_index"
                    :value="region.id"
                    :label="region.name"
                  >
                    {{ region.name }}
                  </el-option>
                </el-select>
              </div>
            </el-col>
          </el-row>

          <el-row v-if="accountUserDetails.access_level == 'sub_region'" class="py-2 pl-12 flex items-center">
            <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
              <p class="text-xs font-bold pb-1">Sub Region</p>
            </el-col>
            <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
              <div class="flex">
                <el-select
                  v-model="accountUserDetails.access_subregion"
                  multiple
                  collapse-tags
                  class="custom-input"
                  placeholder="Sub Region"
                  style="width: 100%"
                  name="Sub Region"
                >
                  <!-- :disabled="accountUserDetails.type != 'head_office'" -->
                  <el-option
                    v-for="(sub_reg, sub_reg_index) in subregions"
                    :key="sub_reg_index"
                    :value="sub_reg.id"
                    :label="sub_reg.name"
                  >
                    {{ sub_reg.name }}
                  </el-option>
                </el-select>
              </div>
            </el-col>
          </el-row>

          <div class="flex justify-end">
            <div class="buttons-parrent2" style="display: flex; justify-content: flex-end;">
              <div class="mx-4 mt-8">
                <BaseButton
                  type="submit"
                  style="width: 100px"
                  buttonclass="btn p-2 text-xs "
                  @click="showEditBaseAccountUserPopup = false"
                  >Cancel</BaseButton
                >
              </div>
            </div>

            <div class="buttons-parrent2" style="display: flex; justify-content: flex-end;">
              <div class="mx-4 mt-8">
                <BaseButton
                  type="submit"
                  style="width: 100px"
                  buttonclass="btn p-2 text-xs "
                  @click="updateAccountUserData"
                  >Update</BaseButton
                >
              </div>
            </div>
          </div>
        </form>
      </el-dialog>
    </div>

    <!-- add new designation dialog -->
    <el-dialog
      title="Add Designation"
      :visible.sync="add_new_designation_dialog"
      width="50%"
    >
      <!-- :before-close="updateList()" -->
      <div v-loading="is_designation_list_loading">
        <div>
          <div
            id="add-designation-wrapper"
            style="height: 200px; overflow-y: auto"
          >
            <div
              v-for="(designation, designation_index) in add_designation_list"
              :key="designation_index"
              class="py-2 flex items-center"
            >
              <el-input
                v-model="designation.name"
                :placeholder="'designation ' + (designation_index + 1)"
                size="medium"
                style="width: 50%"
                type="text"
                @input="designation.isChange = true"
              />
              <div class="ml-5">
                <!-- src="../../../../assets/images/delete-icon.png" -->
                <img
                  class="cursor-pointer"
                  src="../../../assets/images/delete-icon.png"
                  alt="Delete"
                  width="22px"
                  @click="deleteDesignation(designation_index)"
                />
              </div>
            </div>
          </div>

          <div class="flex items-center mt-5">
            <BaseButton
              type="submit"
              style="width: 100px"
              buttonclass="btn p-2 text-xs"
              @click="addMoreDesignation()"
            >
              Add More
            </BaseButton>
          </div>
        </div>

        <span
          slot="footer"
          class="dialog-footer flex"
          style="justify-content: flex-end"
        >
          <BaseButton
            type="submit"
            style="width: 100px"
            buttonclass="btn p-2 text-xs"
            @click="add_new_designation_dialog = false"
          >
            Cancel
          </BaseButton>

          <BaseButton
            type="submit"
            style="width: 100px"
            buttonclass="btn p-2 text-xs ml-2"
            @click="addUpdateDesignation()"
          >
            Update
          </BaseButton>
        </span>
      </div>
    </el-dialog>

    <div v-if="active_tab_link == 'CLUSTER_DETAILS'" class="mt-10">
      <ClusterDetails></ClusterDetails>
    </div>
    <div v-else-if="active_tab_link == 'USER_GROUPS'" class="mt-10">
      <user-groups></user-groups>
    </div>
  </div>
</template>

<script>
import simplebar from "simplebar-vue";
import ClusterDetails from "../clusterDetails/ClusterDetails.vue";
import "simplebar/dist/simplebar.min.css";
import UserAccountsService from "../../../services/userAccountsService";
import { CommonMixin } from "../../../../mixins/common.mixin";
import { serverAddr } from "../../../networkConfig";
import UserGroups from "../userGroups/UserGroups.vue";
import Papa from "papaparse";
import { EventBus } from "../../../eventBus";
import { set } from 'vue';
export default {
  name: "AppStoreDetails",
  components: {
    simplebar,
    ClusterDetails,
    UserGroups,
  },
  mixins: [CommonMixin],
  props: [],
  data() {
    return {
      editBaseAccountUserPopupKey: 0,
      showEditBaseAccountUserPopup: false,
      checkPopup: "",
      accountUserIndex: "",
      accountUserDetails: {},
      id: "",
      head_index: null,
      head_region_index: null,
      region_subregion_index: null,
      subregion_store_index: null,
      regions: [],
      outlets: [],
      subregions: [],
      outletWithUsers: [],
      newArr: [],
      pageInfo: {
        currentPage: 1,
        totalCount: 0,
        pageSize: 10,
      },
      userPermision: [
        {
          id: "outlet",
          name: "Store User",
        },
        {
          id: "region",
          name: "Regional User",
        },
        {
          id: "sub_region",
          name: "Sub Regional User",
        },
        {
          id: "super",
          name: "Super",
        },
        {
          id: "admin",
          name: "Admin",
        },
      ],
      is_store_details_loading: false,
      active_tab_link: "CLUSTER_DETAILS",
      email: "",
	  designationList: [],
      add_designation_list: [],
      add_new_designation_dialog: false,
      is_designation_list_loading: false,
    };
  },
  computed: {
    checkCompany() {
      return JSON.parse(localStorage.getItem('check_company'));
    },
  },
  created() {
    let user_info = this.$store.state.loginUserDetails;
    this.getAllRegion();
    this.getAllSubRegion();
    this.getAllOutlet();
    this.getDesignationList();
    // this.getOutletWithUserDetails({}, this.pageInfo);
    if(user_info) {
      this.email = user_info.email;
    }
    if(this.$route.query) {
      console.log(this.$route , 'route');
        this.active_tab_link = 'CLUSTER_DETAILS';
        this.setActiveTabLink('CLUSTER_DETAILS');
    }
  },
  methods: {
    addNewUserGroup() {
      EventBus.$emit("openNewUserGroup", true);
    },
	getDesignationList() {
      serverAddr
        .post(`/users/designations/list/`)
        .then((res) => {
          let response = JSON.parse(res.data);
          this.designationList = response;

          // this.accountUserDetails.designation = this.designationList[0].id
          // console.log(this.designationList);
        })
        .catch((err) => {
          console.error(err);
        });
    },
	selectDesignInfo(desig){
      this.designationList.forEach(element => {
        if (element.id == desig) {
          this.accountUserDetails.designation_info = element
        }
      });
    },
    addDesignation(event) {
      if (event == "add new") {
        this.accountUserDetails.designation = "";
        this.add_designation_list = this.designationList.slice(0); //get shadow copy of array
        this.add_designation_list.forEach((element) => {
          if (element.id) {
            element.isChange = false;
          }
        });
        this.add_new_designation_dialog = true;
      }
    },

    addMoreDesignation() {
      let designation = {
        name: "",
      };

      this.add_designation_list.unshift(designation);

      // to scroll to top of div after adding one more item to list
      this.scrollToTop("add-designation-wrapper");
    },

    addUpdateDesignation() {
      this.is_designation_list_loading = true; //displyed loader
      this.add_designation_list.forEach((element) => {
        if (element.name.length) {
          if (!element.id) {
            serverAddr
              .post(`/users/designations/save/`, {
                name: element.name,
              })
              .then((response) => {
                if (response.status == 200) {
                }
              })
              .catch((error) => {
                console.error(error);
              });
          } else if (element.id && element.isChange) {
            serverAddr
              .patch(`/users/designations/${element.id}/`, {
                name: element.name,
              })
              .then((response) => {
                if (response.status == 200) {
                }
              })
              .catch((error) => {
                console.error(error);
              });
          }
        }
      });

      setTimeout(() => {
        this.$notify.success({
          title: "Success",
          message: "Designation updated..!",
        });
        this.getDesignationList();
        this.is_designation_list_loading = false;
        this.add_new_designation_dialog = false;
      }, 2000);
    },

    scrollToTop(div) {
      var objDiv = document.getElementById(div);
      objDiv.scrollTo(0, 0);
      // objDiv.scrollTop = objDiv.scrollHeight + '20px';
    },

    deleteDesignation(index) {
      this.is_designation_list_loading = true; //displyed loader
      let designation_id = this.add_designation_list[index].id;
      if (designation_id != undefined) {
        serverAddr
          .delete(`/users/designations/${designation_id}`)
          .then((response) => {
            this.add_designation_list.splice(index, 1);

            setTimeout(() => {
              this.getDesignationList();
              this.is_designation_list_loading = false; //disabld loader
              this.$notify.success({
                title: "Success",
                message: "Designation removed..!",
              });
            }, 2000);
          })
          .catch((e) => {
            console.error("error", e);
            this.is_designation_list_loading = false; //disabld loader
          });
      } else {
        this.add_designation_list.splice(index, 1);
      }
    },
    setActiveTabLink(link) {
      if (link == "ACCOUNT_DETAILS") {
        this.active_tab_link = "ACCOUNT_DETAILS";
      // } else {
      //   this.active_tab_link = "CLUSTER_DETAILS";
      // }
      } else if(link == "USER_GROUPS") {
        this.active_tab_link = "USER_GROUPS";
      } else if(link == "CLUSTER_DETAILS") {
        this.active_tab_link = "CLUSTER_DETAILS";
      }
    },
    deleteUser(email) {
      this.$confirm(
        "Are you sure you want to delete this user? </br>",
        "Delete User",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "Cancel",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          let params = {
            emails: [email],
          };
          UserAccountsService.deleteUsers(params)
            .then((response) => {
              // console.log(JSON.parse(response.data));
              this.getOutletWithUserDetails({}, this.pageInfo);
              this.$notify.success({
                title: "Success",
                message: "User Deleted Successfully",
              });
            })
            .catch((err) => {
              console.error(err);
            });
        })
        .catch(() => {
          // this.$message({
          // 	type: 'info',
          // 	message: 'Delete canceled'
          // });
        });
    },
    getAllOutlet() {
      UserAccountsService.getAllOutlet()
        .then((response) => {
          let outlet = JSON.parse(response.data);
          this.outlets = outlet;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    updateAccountUserData() {
      // console.log(this.accountUserDetails.type)
      let data = [];
      if (this.accountUserDetails.type == "head_office") {
        for (let i = 0; i < this.outletWithUsers.length; i++) {
          if (this.id == this.outletWithUsers[i].id) {
            this.outletWithUsers[i].users[this.accountUserIndex] =
              this.accountUserDetails;
            this.showEditBaseAccountUserPopup = false;
            data = this.outletWithUsers[i].users;
          }
        }
      } else if (this.accountUserDetails.type == "region") {
        this.outletWithUsers[this.head_index].regions[
          this.head_region_index
        ].users[this.accountUserIndex] = this.accountUserDetails;
        this.showEditBaseAccountUserPopup = false;
        data =
          this.outletWithUsers[this.head_index].regions[this.head_region_index]
            .users;
      } else if (this.accountUserDetails.type == "subregion") {
        this.outletWithUsers[this.head_index].regions[
          this.head_region_index
        ].subregions[this.region_subregion_index].users[this.accountUserIndex] =
          this.accountUserDetails;
        this.showEditBaseAccountUserPopup = false;
        data =
          this.outletWithUsers[this.head_index].regions[this.head_region_index]
            .subregions[this.region_subregion_index].users;
      } else {
        this.outletWithUsers[this.head_index].regions[
          this.head_region_index
        ].subregions[this.region_subregion_index].outlets[
          this.subregion_store_index
        ].users[this.accountUserIndex] = this.accountUserDetails;
        this.showEditBaseAccountUserPopup = false;
        data =
          this.outletWithUsers[this.head_index].regions[this.head_region_index]
            .subregions[this.region_subregion_index].outlets[
            this.subregion_store_index
          ].users;
      }
      this.updateUserDetails(data);
    },

    updateUserDetails(data) {
      let params = data.map((user) => {
        let obj = {
          email: user.email ? user.email.toLowerCase() : user.email,
          full_name: user.full_name,
          last_name: user.last_name,
          phone_number: user.phone_number,
          designation: user.designation,
          access_level: user.access_level,
        };
        if (
          user.access_level == "outlet" ||
          user.access_level == "admin" ||
          user.access_level == "employee"
        ) {
          obj.access_outlet = user.access_outlet;
        } else if (user.access_level == "region") {
          obj.access_region =
            typeof user.access_region == "string"
              ? [user.access_region]
              : user.access_region;
        } else if (user.access_level == "sub_region") {
          obj.access_subregion = user.access_subregion;
        } else if (user.access_level == "super") {
          obj.access_country = this.id;
        }
        return obj;
      });

      UserAccountsService.createAccount(params)
        .then((response) => {
          this.$notify.success({
            title: "Success",
            message: "User Updated Successfully",
          });
          this.head_index = null;
          this.head_region_index = null;
          this.region_subregion_index = null;
          this.subregion_store_index = null;
        })
        .catch((err) => {
          console.error(err);
          if (!200 <= err.response.status <= 299) {
            this.$notify.error({
              title: "Fail",
              message: "Something Went Wrong",
            });
          }
        });
    },

    getAllRegion() {
      UserAccountsService.getAllRegion()
        .then((response) => {
          this.regions = JSON.parse(response.data);
        })
        .catch((err) => {
          console.error(err);
          if (!200 <= err.response.status <= 299) {
            this.$notify.error({
              title: "Fail",
              message: "Something Went Wrong",
            });
          }
        });
    },

    getAllSubRegion() {
      UserAccountsService.getAllSubRegion()
        .then((response) => {
          this.subregions = JSON.parse(response.data);
        })
        .catch((err) => {
          console.error(err);
          if (!200 <= err.response.status <= 299) {
            this.$notify.error({
              title: "Fail",
              message: "Something Went Wrong",
            });
          }
        });
    },

    openEditAccountUserPopup(
      employee_data,
      employee_index,
      id,
      type,
      index,
      region_index,
      subregion_index,
      store_index,
      region
    ) {
      // console.log("type", type);
      this.checkPopup = "";
      this.id = id;
      this.head_index = index;
      this.head_region_index = region_index;
      this.region_subregion_index = subregion_index;
      this.subregion_store_index = store_index;
      this.editBaseAccountUserPopupKey += 1; //You take this strategy of assigning keys to children, but whenever you want to re-render a component, you just update the key.
      this.showEditBaseAccountUserPopup = true;
      this.accountUserDetails = employee_data;
      this.accountUserDetails.type = type;
      if (this.accountUserDetails.access_level == "sub_region") {
        this.accountUserDetails.access_region = region;
        // this.accountUserDetails.access_subregion = this.id;
      } else {
        this.accountUserDetails.access_region = this.id;
      }
      this.accountUserIndex = employee_index;
    },
    closePopup() {
      this.showEditBaseAccountUserPopup = false;
      this.editBaseAccountUserPopupKey = 0;
    },
    paginate() {
      return (pageInfo) => {
        this.getOutletWithUserDetails({}, pageInfo);
      };
    },
    toggleRow(index, store_type, region_index, sub_region_index) {
      if (store_type == "HEAD_OFFICE") {
        if (this.outletWithUsers[index].is_toggled == undefined) {
          this.$set(this.outletWithUsers[index], "is_toggled", true);
        } else {
          this.outletWithUsers[index].is_toggled =
            !this.outletWithUsers[index].is_toggled;
        }
      } else if (store_type == "REGION") {
        if (
          this.outletWithUsers[index].regions[region_index].is_toggled ==
          undefined
        ) {
          this.$set(
            this.outletWithUsers[index].regions[region_index],
            "is_toggled",
            true
          );
        } else {
          this.outletWithUsers[index].regions[region_index].is_toggled =
            !this.outletWithUsers[index].regions[region_index].is_toggled;
        }
      } else if (store_type == "SUB_REGION") {
        if (
          this.outletWithUsers[index].regions[region_index].subregions[
            sub_region_index
          ].is_toggled == undefined
        ) {
          this.$set(
            this.outletWithUsers[index].regions[region_index].subregions[
              sub_region_index
            ],
            "is_toggled",
            true
          );
        } else {
          this.outletWithUsers[index].regions[region_index].subregions[
            sub_region_index
          ].is_toggled =
            !this.outletWithUsers[index].regions[region_index].subregions[
              sub_region_index
            ].is_toggled;
        }
      }
    },
    ShowRow(value, Newindex) {
      let data = this.outletWithUsers;
      let newId = "";
      let newOutletId = "";
      data[Newindex].index = !data[Newindex].index;
      for (let i = 0; i < data.length; i++) {
        if (value == data[i].Dataindex) {
          // console.log(value, data[i].Dataindex);
          data[i].indexValue = !data[i].indexValue;
          newId = data[i].id;
        }
        // if (data[i].Dataindex == newId) {
        // 	data[i].indexValue = false;
        // 	newOutletId = data[i].id;
        // }
        // if (data[i].Dataindex == newOutletId) {
        // 	data[i].indexValue = false;
        // 	// newOutletId = data[i].id;
        // }
      }
      this.outletWithUsers = [];
      this.outletWithUsers = data;
    },
    hideRow(value, Newindex) {
      let data = this.outletWithUsers;
      let newId = "";
      let newOutletId = "";
      data[Newindex].index = true;
      for (let i = 0; i < data.length; i++) {
        if (value == data[i].Dataindex) {
          // console.log(value, data[i].Dataindex);
          data[i].indexValue = !data[i].indexValue;
          newId = data[i].id;
          if (data[i].type != "outlet") {
            data[i].index = true;
          }
        }
        if (data[i].Dataindex == newId) {
          data[i].indexValue = false;
          newOutletId = data[i].id;
          if (data[i].type != "outlet") {
            data[i].index = true;
          }
        }
        if (data[i].Dataindex == newOutletId) {
          data[i].indexValue = false;
          if (data[i].type != "outlet") {
            data[i].index = true;
          }
          // newOutletId = data[i].id;
        }
      }
      this.outletWithUsers = [];
      this.outletWithUsers = data;
    },

    getOutletWithUserDetails(params, pageInfo) {
      this.is_store_details_loading = true; //enabled loader
      UserAccountsService.getOutletWithUserDetails(params, pageInfo)
        .then((response) => {
          this.outletWithUsers = [];
          let headOffice = JSON.parse(response.data);
          this.outletWithUsers = headOffice;
          this.is_store_details_loading = false; //disabled loader

          // this.outletWithUsers.forEach(element => {
          // 	element.is_toggled = true
          // });

          // for (let i = 0; i < headOffice.length; i++) {
          // 	headOffice[i].index = false;
          // 	headOffice[i].indexValue = true;
          // 	headOffice[i].Dataindex = headOffice[i].name;
          // 	this.outletWithUsers.push(headOffice[i]);
          // }
          // for (let i = 0; i < headOffice.length; i++) {
          // 	for (let j = 0; j < headOffice[i].regions.length; j++) {
          // 		headOffice[i].regions[j].Dataindex = headOffice[i].id;
          // 		headOffice[i].regions[j].indexValue = true;
          // 		headOffice[i].regions[j].index = false;
          // 		this.outletWithUsers.push(headOffice[i].regions[j]);
          // 		for (
          // 			let k = 0;
          // 			k < headOffice[i].regions[j].outlets.length;
          // 			k++
          // 		) {
          // 			headOffice[i].regions[j].outlets[k].Dataindex =
          // 				headOffice[i].regions[j].id;
          // 			headOffice[i].regions[j].outlets[k].indexValue = true;
          // 			headOffice[i].regions[j].outlets[k].regionOutlet = true;
          // 			this.outletWithUsers.push(headOffice[i].regions[j].outlets[k]);
          // 		}
          // 		for (
          // 			let p = 0;
          // 			p < headOffice[i].regions[j].subregions.length;
          // 			p++
          // 		) {
          // 			headOffice[i].regions[j].subregions[p].Dataindex =
          // 				headOffice[i].regions[j].id;
          // 			headOffice[i].regions[j].subregions[p].indexValue = true;
          // 			headOffice[i].regions[j].subregions[p].index = false;
          // 			this.outletWithUsers.push(
          // 				headOffice[i].regions[j].subregions[p]
          // 			);
          // 			for (
          // 				let h = 0;
          // 				h < headOffice[i].regions[j].subregions[p].outlets.length;
          // 				h++
          // 			) {
          // 				headOffice[i].regions[j].subregions[p].outlets[h].Dataindex =
          // 					headOffice[i].regions[j].subregions[p].id;
          // 				headOffice[i].regions[j].subregions[p].outlets[
          // 					h
          // 				].indexValue = true;
          // 				headOffice[i].regions[j].subregions[p].regionOutlet = false;
          // 				this.outletWithUsers.push(
          // 					headOffice[i].regions[j].subregions[p].outlets[h]
          // 				);
          // 			}
          // 		}
          // 	}
          // }
          // this.newArr = JSON.parse(response.data);
          // this.pageInfo.totalCount = JSON.parse(response.data).count;
        })
        .catch((e) => {
          console.error("error", e);
          this.is_store_details_loading = false; //disabled loader
        });
    },

    createCsvJson(tableData) {
      if (tableData.length) {
        var result = tableData.map((row) => {
          let user = [];
          var obj = {};
          obj = {
            "Account Name": row.name,
            "Account Type": row.type,
            "Full Name": "",
            Designation: "",
            "User Permission": "",
            Access: "",
          };
          if (row.users.length) {
            user = row.users.map((user) => {
              obj["Full Name"] = user.full_name + " " + user.last_name;
              obj["User Permission"] = user.access_level;
              obj.Designation = user.designation;
              if (user.access_level == "outlet") {
                for (let i = 0; i < this.outlets.length; i++) {
                  if (user.access_outlet == this.outlets[i].id) {
                    obj.Access = this.outlets[i].name;
                  }
                }
              }
              if (user.access_level == "region") {
                for (let i = 0; i < this.regions.length; i++) {
                  if (user.access_region == this.regions[i].id) {
                    obj.Access = this.regions[i].name;
                  }
                }
              }
              if (user.access_level == "sub_region") {
                for (let i = 0; i < this.subregions.length; i++) {
                  if (user.access_subregion == this.subregions[i].id) {
                    obj.Access = this.subregions[i].name;
                  }
                }
              }
              return obj;
            });
            for (let i in user) {
              // console.log(user[i]);
              return user[i];
            }
          } else {
            return obj;
          }
        });
        return result;
      }
    },

    downloadCsvReport(tableData) {
      // var export_csv = tableData;
      var export_csv = this.createCsvJson(tableData);
      // *****************download csv file************************************
      var csv = Papa.unparse(export_csv);
      var csvData = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const documentName = `location_data_${new Date()}`;
      var csvURL = null;
      if (navigator.msSaveBlob) {
        csvURL = navigator.msSaveBlob(csvData, `${documentName}.csv`);
      } else {
        csvURL = window.URL.createObjectURL(csvData);
      }

      var tempLink = document.createElement("a");
      tempLink.href = csvURL;
      tempLink.setAttribute("download", "download.csv");
      tempLink.click();
      // if (this.quickReports == "wfr") {
      // 	tempLink.setAttribute(
      // 		"download",
      // 		`Workforce Report ${localStorage.getItem("dateRange")}.csv`
      // 	);
      // 	tempLink.click();
      // } else {
      // 	tempLink.setAttribute(
      // 		"download",
      // 		`${this.quickReports} Repot ${localStorage.getItem("dateRange")} .csv`
      // 	);
      // 	tempLink.click();
      // }
    },
    // getAllOutletUsers() {
    // 	serverAddr
    // 		.get(
    // 			`/outlet/users/?page=${this.current_page_no}&page_size=${
    // 				this.per_page_store
    // 			}`,
    // 			{}
    // 		)
    // 		.then(this.getAllOutletUsersNC)
    // 		.catch(error => {
    // 			this.$notify.error({
    // 				title: "fail",
    // 				message: JSON.parse(error.response.data).name[0]
    // 			});
    // 		});
    // },
    // redirectToOutletEdit(outletData) {
    // 	this.$router.push({ path: `/app-update-store/${"edit"}/` });
    // 	this.$store.commit("getOutletData", outletData);
    // },
    // redirectToOutletView(outletData) {
    // 	this.$store.commit("getOutletData", outletData);
    // 	this.$router.push(`/app-update-store/${"view"}/`);
    // },
    // handleSizeChangeForStoreList(val) {
    // 	this.per_page_store = val;
    // 	this.getAllOutletUsers();
    // },
    // handleCurrentChangeForStoreList(val) {
    // 	this.allOutletData = [];
    // 	this.getAllOutletUsers();
    // },
    // redirectToAddStoreUi() {
    // 	this.$router.push("/account");
    // }
  },
};
</script>

<style lang="scss" scoped>
@import "./AppStoreDetails.scss";
@import "./AppStoreDetailsM.scss";
</style>

<style lang="scss">
.AppStoreDetails
  .el-pagination.is-background
  .el-pager
  li:not(.disabled).active {
  background-color: #f7ba89;
}
.AppStoreDetails
  .el-pagination.is-background
  .el-pager
  li:not(.disabled):hover {
  color: #000;
}
.AppStoreDetails .el-pagination .btn-next,
.AppStoreDetails .el-pagination .btn-prev {
  border-radius: 50% !important;
}
.AppStoreDetails .el-pager li {
  border-radius: 50% !important;
}
.AppStoreDetails .el-dialog__header {
  background: #32343d;
}
.AppStoreDetails .el-message-box__header {
  color: white;
  font-size: 15px;
  /* font-weight: 600; */
}
</style>
<style>
.el-tooltip__popper {
  max-width: 500px;
  font-size: 14px;
  text-transform: capitalize;
}
.el-message-box {
  border: none !important;
}
.el-message-box__header {
  background: #32343d !important;
}
.el-message-box__title {
  color: white !important;
  font-size: 15px !important;
  /* font-weight: 600; */
}
.el-button--small {
  padding: 6px 15px;
  background: #e29d5a !important;
  border: 1px solid #e29d5a !important;
  color: #fff;
}
</style>
